module.exports = __webpack_public_path__ + "img/print_code_bg.40d33726.png";